// extracted by mini-css-extract-plugin
export var about = "about-module--about--25b2c";
export var col = "about-module--col--9f0c2";
export var row = "about-module--row--2a021";
export var title = "about-module--title--f4655";